import { UPDATE_PENDENCY_SUMMARY } from '../actions/pendencyActions';
import { AUDIO_ALERT_FILES } from '../../shared/utils/constants';

const chatAudio = new Audio(AUDIO_ALERT_FILES.CHAT);
const medicalAudio = new Audio(AUDIO_ALERT_FILES.MEDICAL);
const smartGoAudio = new Audio(AUDIO_ALERT_FILES.SMARTGO);

const initialState = {
  smartGoPendency: 0,
  totalMedicalPendencyQuantity: 0,
  lateMedicalPendencyQuantity: 0,
  unreadChatMessages: 0,
  communicationPendency: 0,
  routineRecordsPendency: 0,
  chatSummary: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_PENDENCY_SUMMARY:
      try {
        if (action.payload.unreadChatMessages > state.unreadChatMessages) {
          chatAudio.play();
        }
      } catch (e) {
        console.error(e);
      }
      try {
        if (action.payload.smartGoPendency > 0) {
          smartGoAudio.play();
        }
      } catch (e) {
        console.error(e);
      }
      try {
        if (action.payload.lateMedicalPendencyQuantity) {
          medicalAudio.play();
        }
      } catch (e) {
        console.error(e);
      }

      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
